export default __webpack_public_path__ + "static/media/244.5135395f.gif";